import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, ActivationEnd, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {filter} from 'rxjs/operators';
import {Select} from '@ngxs/store';
import {Observable} from 'rxjs/internal/Observable';
import {IUser} from '../../interfaces/user.interface';
import {UserRolesEnum} from '../../interfaces/UserRolesEnum';
import { BasicSubscriptionPlanGuard } from '../../guards/basic-subscription-plan.guard';
import { PharmacyState } from '../../states/pharmacy/pharmacy.state';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IPharmacy } from '../../interfaces/pharmacy.interface';
import { AuthState } from '../../states/auth/auth.state';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CustomerSupportService } from '../../services/customer-support.service';

declare const Chargebee: any;

@UntilDestroy()
@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  providers: [CustomerSupportService]
})
export class SidebarMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  environment = environment;

  isInventoryDynamicChild: boolean;
  isOrderHistoryDynamicChild: boolean;
  isNotBasicPlan: boolean;

  UserRolesEnum = UserRolesEnum;
  adminRoles = [
    UserRolesEnum.GlobalAdmin,
    UserRolesEnum.CompanyAdmin,
    UserRolesEnum.PharmacyAdmin,
  ];
  isCollapsed: boolean = true;

  TUTORIALS_LINK =
    'https://help.c2keep.com';
  CUSTOMER_PORTAL_LINK = 'javascript:void(0)';
  CUSTOMER_PORTAL_LINK_SAFE: SafeResourceUrl;

  @Select(PharmacyState.currentPharmacy)
  currentPharmacy$: Observable<IPharmacy>;
  @Select(PharmacyState.pricingOption) pricingOption$: Observable<number>;
  @Select(AuthState.activeUserIsLoggedInUser)
  activeUserIsLoggedInUser$: Observable<any>;
  @Select(PharmacyState.compoundingEnabled) compoundingEnabled$: Observable<boolean>;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private basicPlanGuard: BasicSubscriptionPlanGuard,
    private sanitizer: DomSanitizer,
    private customerSupportService: CustomerSupportService
  ) {
    this.CUSTOMER_PORTAL_LINK_SAFE = this.sanitizer.bypassSecurityTrustResourceUrl(this.CUSTOMER_PORTAL_LINK);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((e: ActivationEnd) => e instanceof ActivationEnd))
      .subscribe((e: ActivationEnd) => {
        if (
          !e.snapshot.routeConfig.children &&
          !e.snapshot.routeConfig.loadChildren
        ) {
          const isChildInventoryRoute =
            this.router.url.includes('/inventory') &&
            !!e.snapshot.routeConfig.component &&
            e.snapshot.params?.id !== undefined;

          this.isInventoryDynamicChild =
            isChildInventoryRoute && e.snapshot.data?.inventory;
          this.isOrderHistoryDynamicChild =
            isChildInventoryRoute && e.snapshot.data?.orderHistory;
        }
      });

    this.pricingOption$.pipe(untilDestroyed(this)).subscribe(() => {
      this.isNotBasicPlan = this.basicPlanGuard.canActivate() as boolean;
    });
  }

  ngAfterViewInit(): void {
   setTimeout(() => {
    try {
      Chargebee?.registerAgain();
    } catch (error) {
      if (error.toString().includes('getCart')) {
          Chargebee?.init({site: "c2keep"});
          Chargebee?.registerAgain();
      } else {
          console.log("Chargebee is undefined")
          location.reload(); //Chargebee is not defined
      }
    }
   });
  }

  isActiveRoute(route: string): boolean {
    return this.router.url.includes(route);
  }

  onExpanderClick(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  openTutorials(): void {
    window.open(this.TUTORIALS_LINK, '_blank');
  }

  openCustomerPortal(): void {
    window.open(this.CUSTOMER_PORTAL_LINK, '_self');
  }

  openCustomerSupport(): void {
    this.customerSupportService.toggle();
  }

  ngOnDestroy(): void {
    this.customerSupportService.logout();
  }

}
